import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pcc8wbctty: FaireBrandEntity = {
  token: "b_pcc8wbctty",
  type: "brand",
  name: "Sunday Edition by LE LIS",
  avatarUrl:
    "https://cdn.faire.com/fastly/e2058bc3c09e89128b35cdc2854939dfd85cc36fcb36d39466d5ac00ee41fd03.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e11c69a7844c856f3a7f4434fb1b4045c2a57dd2a525c7d8ccc4e82b2e6da2d6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/e2058bc3c09e89128b35cdc2854939dfd85cc36fcb36d39466d5ac00ee41fd03.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e11c69a7844c856f3a7f4434fb1b4045c2a57dd2a525c7d8ccc4e82b2e6da2d6.png",
  location: "Vernon, CA, USA",
  minimumOrderDollars: 60,
  rating: 5,
  reviewCount: 204,
  isTopShop: true,
  isInsider: true,
  description:
    "SundayEdition celebrates the everyday woman who’s looking for fashion that reflects real life.\nFrom essential pieces made to navigate the hustle and bustle of everyday, to special pieces that allow you to creatively express your individuality while embracing authenticity; we want to be part of your story, in every version of you.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:21:49.112Z",
    importedBy: "entity-db-cli",
  },
};
